import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class AccountTaxesService {
  constructor() {}
  getSalesTax(taxList: any): any {
    const salesTaxInfo = taxList?.filter(
      (taxInfo: any) => taxInfo?.taxCode === environment?.taxCodes?.SALES_TAX
    );
    return salesTaxInfo || [];
  }

  getNevadaLiveEntertainmentTax(taxList: any): any {
    const nevadaLiveEntertainmentTaxInfo = taxList?.filter(
      (taxInfo: any) => taxInfo?.taxCode === environment?.taxCodes?.NV_LIVE_ENT
    );
    return nevadaLiveEntertainmentTaxInfo || [];
  }
}
